import type { BaseItemSchema, Choice } from "@memorang/types";
import type { ReactNode } from "react";
import Box from "../../../Box";
import ChoicesList from "../ChoicesList";

type Props = {
	multiSelect?: boolean;
	isSummativeTest?: boolean;
	isAnswered?: boolean;
	inReviewMode?: boolean;
	shouldShowCrossout?: boolean;
	selectedChoiceIds?: string[];
	correctAnswerIds?: string[];
	crossedOutChoiceIds?: string[];
	choices: Choice[];
	showHint?: boolean;
	currentItem: BaseItemSchema;
	handleSelectChoice: (
		choiceId: string,
		crossingOut?: boolean,
		currentOrders?: string[],
	) => void;
	correctAnswerOrders?: string[];
	renderHintContainer: () => ReactNode;
	currentUserResponse?: unknown;
	setUserResponse: (itemId: number, data: unknown) => void;
	handleSkipSequence: () => void;
	fontSize?: number;
};

const MCQ = ({
	multiSelect,
	isSummativeTest,
	isAnswered,
	inReviewMode = false,
	shouldShowCrossout = true,
	selectedChoiceIds,
	correctAnswerIds,
	crossedOutChoiceIds,
	choices,
	showHint,
	handleSelectChoice,
	currentItem,
	correctAnswerOrders,
	renderHintContainer,
	currentUserResponse,
	setUserResponse,
	handleSkipSequence,
	fontSize,
}: Props) => {
	const { response } = currentItem;
	const shuffle =
		response.type === "choice"
			? Boolean(response.shuffle) && !inReviewMode
			: false;
	const maxChoiceCount =
		response.type === "choice" ? response.maxCorrectChoices : undefined;
	const useCardWrapper = !isSummativeTest;
	const showCrossOut = !isSummativeTest && shouldShowCrossout;

	return (
		<Box gap={16}>
			<ChoicesList
				choices={choices}
				useCardWrapper={useCardWrapper}
				showCrossOut={showCrossOut}
				isAnswered={isAnswered}
				isSummativeTest={isSummativeTest}
				selectedChoiceIds={selectedChoiceIds}
				multiSelect={multiSelect}
				correctAnswerIds={correctAnswerIds}
				handleSelectChoice={handleSelectChoice}
				crossedOutChoiceIds={crossedOutChoiceIds}
				itemId={currentItem.id!}
				correctAnswerOrders={correctAnswerOrders}
				maxChoiceCount={maxChoiceCount}
				currentUserResponse={currentUserResponse}
				setUserResponse={setUserResponse}
				handleSkipSequence={handleSkipSequence}
				isSequence={
					response.type === "choice" &&
					response.shuffle === false &&
					Boolean(correctAnswerOrders?.length)
				}
				shuffle={shuffle}
				fontSize={fontSize}
			/>
			{showHint && choices.length > 0 ? (
				<Box>{renderHintContainer()}</Box>
			) : null}
		</Box>
	);
};

export default MCQ;
